import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./style.css";

interface CustomDrilldownProps {
  show?: boolean;
  width?: string;
  title?: any;
  level?: number;
  onClose?: () => void;
  children?: React.ReactNode;
}

const CustomDrilldown: React.FC<CustomDrilldownProps> = ({
  show,
  width = "70",
  title,
  level = 1,
  onClose,
  children,
}) => {
  return (
    <Offcanvas
      placement="end"
      show={show}
      backdropClassName={`custom-drilldown-backdrop level-${level}`}
      className={`custom-drilldown width_${width} level-${level}`}
    >
      <div className="custom_scroll" style={{ maxHeight: "900px", overflowY: "auto" }}>
        <div className="flex items-center justify-between p-3 border-b">
          <h6 className="mb-0 font-bold">{title as any}</h6>
          <button className="btn-close text-reset" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="p-3 overflow-auto h-full">{children}</div>
      </div>
    </Offcanvas>
  );
};

export default CustomDrilldown;
